import { render, staticRenderFns } from "./DirectorySidebar.vue?vue&type=template&id=e4f5088c&scoped=true"
import script from "./DirectorySidebar.vue?vue&type=script&lang=js"
export * from "./DirectorySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f5088c",
  null
  
)

export default component.exports